module.exports = __webpack_public_path__ + "static/img/overall_balance.389daeda.png";